import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { BaseSubmitAction, BaseSubmitProps, ExecutionResult } from '../../BaseSubmitAction';
import { formatDateToCustomFormat, replacePlaceholders } from 'lib/forms/FormFieldUtils';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { FormFieldProps } from 'lib/forms';

type SendTextPayload = {
  phoneNumber: string;
  link: string;
};

type TextFields = Feature.EnterpriseWeb.RenewalByAndersen.Forms.SubmitActions.SendText['fields'];

export class SendText extends BaseSubmitAction {
  constructor(params: BaseSubmitProps) {
    super(params);
  }

  private getSubstitutedValue(fieldName: keyof TextFields): string {
    const actionFieldsProps = this.actionFieldsProps as TextFields;

    this.formProps?.fields.children.forEach((page) =>
      page.fields?.children.forEach((field: FormFieldProps) => {
        if (field.templateName === 'Date' && field.fields.fieldName?.value.trim()) {
          const dateField = field.fields.fieldName?.value;
          this.formData[dateField] = formatDateToCustomFormat(this.formData[dateField]);
        }
      })
    );

    if (actionFieldsProps) {
      return replacePlaceholders(
        (actionFieldsProps[fieldName] as Field<string>)?.value,
        this.formData,
        true
      );
    }
    return '';
  }

  private preparePayload(): SendTextPayload {
    const phoneNumber = this.getSubstitutedValue('phoneNumber' as keyof TextFields);
    const message = this.getSubstitutedValue('message' as keyof TextFields);

    return {
      phoneNumber: phoneNumber,
      link: message,
    };
  }

  override async executeAction(): Promise<ExecutionResult> {
    const payload: SendTextPayload = this.preparePayload();
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    };

    const response = await fetch(`/api/rba/submit-actions/send-text`, requestOptions);

    return new Promise<ExecutionResult>((resolve) => {
      resolve({
        success: response.status === 200,
        errorMessage: this.actionFieldsProps?.errorMessage?.value || '',
      });
    });
  }
}
